module.exports = __webpack_public_path__ + "media/store/images/icon-buttons/align-left-fb5c1a8ad9f9684febdae852e79dd5c7.svg";